import ElectricSign from './electricSignStore';

export default {
    ElectricSign: new ElectricSign(),
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/stores/dev/index.ts